/* eslint-disable */

import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
} from "reactstrap";

import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";

import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
  Fn_FillListData2,
  Fn_AddEditDataH,
  Fn_DeleteData,
  Fn_FillListDataGlobal,
  showToastWithCloseButton,
} from "../../store/functions";
import AddDeleteTableRows from "./AddDeleteTableRow";
import AddDeleteTableRowsTax from "./AddDeleteTableRowtax";
import { toggleRightSidebar } from "store/actions";
import AddDeleteTableRowsCharges from "./AddDeleteTableRowCharges";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { event } from "jquery";

export const formatDate = () => {
  var d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

class AddMoneyReceipt extends Component {
  constructor(props) {
    super(props);
    const today = new Date().toISOString().split("T")[0];
    this.state = {
      // Basic form data
      id: 0,
      formData: {},
      success_msg: false,
      searchInvoice: "",
      date: today,
      modal_fullscreen: false,

      // Ledger and amount related
      F_LedgerMaster: "",
      F_SalesLedger: "",
      Amount: 0,
      Narration: "",
      LedgerMasterDr: "",
      LedgerMasterCr: "",
      currBalance: "0.00",
      SelectMoneyMaster: [],
      MoneyMaster: [],
      currBalanceMaster: [],

      // Cheque details
      ChequeNo: "",
      DrawnOn: "",
      ChequeDate: "",

      // Auto/Manual mode data
      MR_AutoFill: [],
      manualData: [],
      isAuto: false,

      // Amount calculations
      openBalance: "0.00",
      LineTotalAmt: "0.00",
      NetAmt: "0.00",
      DueAmt: "0.00",

      // Master data
      F_InvoiceMasterH: "",
      F_VoucherTypeMaster: "",
      LedgerMasterr: [],
      SalesLedgerr: [],

      // Invoice related
      InvoiceIds: [],
      NetAmounts: "",
      DueAmounts: "",
      voucherNo: "",

      // Token and options
      BoldToken: [
        {
          Token: "",
        },
      ],
      VoucherGlobalOptions: [
        {
          IsVoucherNoEnable: false,
          VoucherNo: "",
          BackgroundColor: "",
          TextColor: "",
          IsActualSoot: false,
        },
      ],

      isInitialLoad: true,
      isAddMode: true,
      canPrint: false,
      isMoneyReceiptDisabled: true,
      isEditMode: false,
      isLedgerSelected: false,
      isMoneyReceiptSelected: false,
      isFieldsDisabled: false,
      isSaveDisabled: false,
      isCancelDisabled: false,
      isEditEnabled: false,
      isPrintEnabled: false,
      isAddEnabled: false,
    };

    this.obj = this;
    this.formTitle = "Money Receipt";
    this.breadCrumbTitle = "Money Receipt";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL_SAVEH = API_WEB_URLS.AddMoneyReceipt + "/0/token";

    // Bind the tog_fullscreen function
    this.tog_fullscreen = this.tog_fullscreen.bind(this);
  }

  syno() {
    this.setState({
      success_msg: false,
    });
  }

  componentDidMount() {
    //navbar-header
    const obj = JSON.parse( sessionStorage.getItem("authUser"));

    Fn_FillListData(
      this.obj,
      "BoldToken",
      API_WEB_URLS.MASTER + "/0/token/BoldToken/Id/0"
    );
    //Filling DropDowns
    Fn_FillListData(
      this.obj,
      "LedgerMasterr",
      API_WEB_URLS.MASTER + "/0/token/LedgerMasterr/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "SalesLedgerr",
      API_WEB_URLS.MASTER + "/0/token/SalesLedgerr/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "SelectMoneyMaster",
      API_WEB_URLS.MASTER + "/0/token/SelectMoneyMaster/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "Unit",
      API_WEB_URLS.MASTER + "/0/token/Unit/Id/0"
    );

    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Only update if MR_AutoFill data has actually changed and is not empty
    if (
      this.state.MR_AutoFill !== prevState.MR_AutoFill &&
      this.state.MR_AutoFill &&
      this.state.MR_AutoFill.length > 0 &&
      JSON.stringify(this.state.MR_AutoFill) !==
        JSON.stringify(prevState.MR_AutoFill)
    ) {
      // Calculate NetAmt for each row
      const updatedData = this.state.MR_AutoFill.map(item => {
        const dueAmount = parseFloat(item.DueAmt) || 0;
        const amount = parseFloat(item.Amount) || 0;
        const validAmount = Math.min(amount, dueAmount);
        return {
          ...item,
          Amount: validAmount.toFixed(2),
          NetAmt: validAmount.toFixed(2),
        };
      });

      // Calculate totals
      const totalAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.Amount) || 0);
      }, 0);

      const totalDueAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.DueAmt) || 0);
      }, 0);

      const totalNetAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.NetAmt) || 0);
      }, 0);

      // Get current balance from currBalanceMaster
      const selectedLedger = this.state.currBalanceMaster.find(
        item => item.F_LedgerMaster == this.state.F_LedgerMaster
      );
      const currentBalance = selectedLedger
        ? selectedLedger.currBalance
        : "0.00";

      // Only update state if values have actually changed
      if (
        totalDueAmount !== parseFloat(this.state.LineTotalAmt) ||
        totalNetAmount !== parseFloat(this.state.NetAmt)
      ) {
        this.setState({
          MR_AutoFill: updatedData,
          currBalance: currentBalance,
          LineTotalAmt: totalDueAmount.toFixed(2),
          NetAmt: totalNetAmount.toFixed(2),
        });
      }
    }
  }

  distributeAmount = totalAmount => {
    const currentData = this.state.isAuto
      ? this.state.MR_AutoFill
      : this.state.manualData;
    if (!currentData || currentData.length === 0) return;

    // Ensure totalAmount is a valid number
    let remainingAmount = parseFloat(totalAmount) || 0;

    // Create a copy of the data to work with
    const updatedData = currentData.map(item => {
      // Ensure dueAmount is a valid number
      const dueAmount = parseFloat(item.DueAmt) || 0;
      let paidAmount = 0;

      if (remainingAmount > 0) {
        // Calculate paid amount and ensure it's a valid number
        paidAmount = Math.min(remainingAmount, dueAmount);
        remainingAmount = parseFloat((remainingAmount - paidAmount).toFixed(2));
      }

      return {
        ...item,
        Amount: paidAmount.toFixed(2),
        NetAmt: paidAmount.toFixed(2), // Use paid amount for NetAmt
        editableAmount: paidAmount.toFixed(2), // For manual mode
      };
    });

    // Calculate totals with proper float parsing
    const totalPaidAmount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.Amount) || 0);
    }, 0);

    const totalDueAmount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.DueAmt) || 0);
    }, 0);

    const totalNetAmount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.NetAmt) || 0);
    }, 0);

    // Calculate difference amount as Amount - total paid amount
    const diffAmount = parseFloat(
      (parseFloat(totalAmount) - totalPaidAmount).toFixed(2)
    );

    // Extract data for non-zero Amount items
    const nonZeroItems = updatedData.filter(
      item => parseFloat(item.Amount) > 0
    );

    // Create comma-separated strings for Ids, NetAmts, and DueAmts
    const invoiceIds = nonZeroItems.map(item => item.Id).join(",");
    const netAmounts = nonZeroItems.map(item => item.NetAmt).join(",");
    const dueAmounts = nonZeroItems.map(item => item.DueAmt).join(",");

    if (this.state.isAuto) {
      // For auto mode, update the state with the distributed amounts
      this.setState({
        MR_AutoFill: updatedData.map(item => ({
          ...item,
          NetAmt: item.Amount, // Set NetAmt to match Amount for auto mode
        })),
        LineTotalAmt: totalDueAmount.toFixed(2),
        NetAmt: totalNetAmount.toFixed(2),
        diffAmt: diffAmount.toFixed(2),
        InvoiceIds: invoiceIds,
        NetAmounts: netAmounts,
        DueAmounts: dueAmounts,
      });
    } else {
      // For manual mode, update both manualData and MR_AutoFill
      this.setState({
        manualData: updatedData,
        MR_AutoFill: updatedData.map(item => ({
          ...item,
          NetAmt: item.Amount, // Set NetAmt to match Amount for consistency
        })),
        LineTotalAmt: totalDueAmount.toFixed(2),
        NetAmt: totalNetAmount.toFixed(2),
        diffAmt: diffAmount.toFixed(2),
        InvoiceIds: invoiceIds,
        NetAmounts: netAmounts,
        DueAmounts: dueAmounts,
      });
    }
  };

  handleChange = async e => {
    const { name, value, type, checked } = e.target;

    // Prevent default form submission
    e.preventDefault();

    // Handle select elements
    if (name === "F_LedgerMaster" || name === "F_SalesLedger") {
      const selectedId = value;

      this.setState(
        {
          [name]: selectedId,
          F_LedgerMaster:
            name === "F_LedgerMaster" ? selectedId : this.state.F_LedgerMaster,
          F_SalesLedger:
            name === "F_SalesLedger" ? selectedId : this.state.F_SalesLedger,
          isLedgerSelected: name === "F_LedgerMaster" && selectedId !== "",
          isInitialLoad: false,
          isEditMode: name === "F_LedgerMaster" && selectedId !== "",
          // Set ChequeNo to "0" when F_SalesLedger is 1 (Cash)
          ChequeNo: selectedId === "1" ? "0" : this.state.ChequeNo
        },
        () => {
          // If F_LedgerMaster is selected, fetch and fill MR_AutoFill data and current balance
          if (name === "F_LedgerMaster" && selectedId) {
            Fn_FillListData(
              this.obj,
              "MR_AutoFill",
              `${API_WEB_URLS.MASTER}/0/token/MR_AutoFill/Id/${selectedId}`
            );

            // Fetch current balance
            Fn_FillListData(
              this.obj,
              "currBalanceMaster",
              `${API_WEB_URLS.MASTER}/0/token/currBalanceMaster/Id/${selectedId}`
            );

            // Update narration when ledger is selected
            this.updateNarration();
          }
          // If F_SalesLedger is selected, update narration
          if (name === "F_SalesLedger") {
            this.updateNarration();
          }
        }
      );
    } else if (name === "Amount") {
      // Handle Amount field change with proper float parsing
      const amount = parseFloat(value) || 0;
      this.setState({ Amount: amount }, () => {
        // Distribute the amount across rows
        this.distributeAmount(amount);
        // Update narration to reflect new amount
        this.updateNarration();
      });
    } else if (
      name === "ChequeNo" ||
      name === "DrawnOn" ||
      name === "ChequeDate"
    ) {
      // Update state for cheque details
      this.setState(
        {
          [name]: value,
        },
        () => {
          // Update narration with cheque details
          this.updateNarration();
        }
      );
    } else if (name === "MoneyReceipt") {
      this.setState({
        MoneyReceipt: value,
        isMoneyReceiptSelected: value !== '',
        isInitialLoad: false,
        isAuto: false, // Force manual mode when MoneyReceipt is selected
        isEditMode: false,
        // Enable Add, Edit and Print buttons when MoneyReceipt is selected
        isAddEnabled: true,
        isEditEnabled: value !== '', // Enable Edit only if MoneyReceipt has value
        isPrintEnabled: value !== '', // Enable Print only if MoneyReceipt has value
        // Disable Save and Cancel buttons initially
        isSaveDisabled: true,
        isCancelDisabled: true
      });
      const res = await Fn_FillListData(
        this.obj,
        "MoneyReceiptHEdit",
        `${API_WEB_URLS.MASTER}/0/token/MoneyReceiptHEdit/Id/${value}`
      );
      console.log(res);

      const res1 = await Fn_FillListData(
        this.obj,
        "MoneyReceiptLEdit",
        `${API_WEB_URLS.MASTER}/0/token/MoneyReceiptLEdit/Id/${value}`
      );
      console.log("res1", res1);

      // Set values from MoneyReceiptHEdit response
      if (res && res.length > 0) {
        this.setState({
          F_LedgerMaster: res[0].F_LedgerMaster || "",
          F_SalesLedger: res[0].F_SalesLedger || "",
          Amount: res[0].Amount || "",
          Narration: res[0].Narration || "",
          ChequeNo: res[0].ChequeNo || "",
          DrawnOn: res[0].DrawnOn || "",
          ChequeDate: res[0].ChequeDate || "",
          date: res[0].VoucherDate || "",
          LedgerMasterDr: res[0].F_SalesLedger || "",
          LedgerMasterCr: res[0].F_LedgerMaster || "",
          isAuto: false, // Force manual mode
        });

        // If there's line item data, set it to manualData
        if (res1 && res1.length > 0) {
          // Create line items with NetAmt and DueAmt from res1
          const lineItems = res1.map((item, index) => ({
            sno: index + 1,
            Id: item.Id || "",
            VoucherNo: item.VoucherNo || "",
            VoucherDate: item.VoucherDate || "",
            DueAmt: item.DueAmt || "0.00",
            NetAmt: item.Paid || "0.00",
            editableAmount: item.Paid || "0.00", // Set editableAmount for manual mode
          }));

          // Calculate totals from res1 data
          const totalDueAmount = res1.reduce((sum, item) => {
            return sum + (parseFloat(item.DueAmt) || 0);
          }, 0);

          const totalNetAmount = res1.reduce((sum, item) => {
            return sum + (parseFloat(item.Paid) || 0);
          }, 0);

          // Get current balance from currBalanceMaster
          const selectedLedger = this.state.currBalanceMaster.find(
            item => item.F_LedgerMaster == res[0].F_LedgerMaster
          );
          const currentBalance = selectedLedger
            ? selectedLedger.currBalance
            : "0.00";

          // Set state with manual data
          this.setState({
            manualData: lineItems,
            currBalance: currentBalance,
            LineTotalAmt: totalDueAmount.toFixed(2),
            NetAmt: totalNetAmount.toFixed(2),
            diffAmt: (parseFloat(res[0].Amount) - totalNetAmount).toFixed(2),
          });
        }
      }
    } else {
      this.setState({
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  updateNarration = () => {
    const {
      F_SalesLedger,
      ChequeNo,
      DrawnOn,
      ChequeDate,
      SalesLedgerr,
      Amount,
    } = this.state;

    if (F_SalesLedger) {
      // Find the selected ledger name
      const selectedSLedger = SalesLedgerr.find(
        Sledger => Sledger.Id === F_SalesLedger
      );
      const SledgerName = selectedSLedger ? selectedSLedger.Name : "";

      let narration = "";

      // Check if the selected ledger is cash
      if (F_SalesLedger == 100060016) {
        narration = `Being Cash ${Amount || "0.00"} Received`;
      } else if (F_SalesLedger == 100060017) {
        narration = `Receipt from Bank Transfer`;
        if (ChequeNo) {
          narration += ` No. ${ChequeNo}`;
        }
        if (DrawnOn) {
          narration += ` Drawn on ${DrawnOn}`;
        }
        if (ChequeDate) {
          // Format the date to DD/MM/YYYY
          const formattedDate = new Date(ChequeDate).toLocaleDateString(
            "en-GB"
          );
          narration += ` dated ${formattedDate}`;
        }
      } else if (F_SalesLedger == 100060018) {
        narration = `Receipt from Cheque`;

        if (ChequeNo) {
          narration += ` No. ${ChequeNo}`;
        }
        if (DrawnOn) {
          narration += ` Drawn on ${DrawnOn}`;
        }
        if (ChequeDate) {
          // Format the date to DD/MM/YYYY
          const formattedDate = new Date(ChequeDate).toLocaleDateString(
            "en-GB"
          );
          narration += ` dated ${formattedDate}`;
        }
      } else if (F_SalesLedger == 100060019) {
        narration = `Receipt from NEFT`;

        if (ChequeNo) {
          narration += ` No. ${ChequeNo}`;
        }
        if (DrawnOn) {
          narration += ` Drawn on ${DrawnOn}`;
        }
        if (ChequeDate) {
          // Format the date to DD/MM/YYYY
          const formattedDate = new Date(ChequeDate).toLocaleDateString(
            "en-GB"
          );
          narration += ` dated ${formattedDate}`;
        }
      } else if (F_SalesLedger == 100060020) {
        narration = `Receipt from RTGS`;

        if (ChequeNo) {
          narration += ` No. ${ChequeNo}`;
        }
        if (DrawnOn) {
          narration += ` Drawn on ${DrawnOn}`;
        }
        if (ChequeDate) {
          // Format the date to DD/MM/YYYY
          const formattedDate = new Date(ChequeDate).toLocaleDateString(
            "en-GB"
          );
          narration += ` dated ${formattedDate}`;
        }
      } else if (F_SalesLedger == 100060098) {
        narration = `Receipt from IMPS`;

        if (ChequeNo) {
          narration += ` No. ${ChequeNo}`;
        }
        if (DrawnOn) {
          narration += ` Drawn on ${DrawnOn}`;
        }
        if (ChequeDate) {
          // Format the date to DD/MM/YYYY
          const formattedDate = new Date(ChequeDate).toLocaleDateString(
            "en-GB"
          );
          narration += ` dated ${formattedDate}`;
        }
      } else if (F_SalesLedger ==100060022) {
        narration = `Receipt from UPI`;

        if (ChequeNo) {
          narration += ` No. ${ChequeNo}`;
        }
        if (DrawnOn) {
          narration += ` Drawn on ${DrawnOn}`;
        }
        if (ChequeDate) {
          // Format the date to DD/MM/YYYY
          const formattedDate = new Date(ChequeDate).toLocaleDateString(
            "en-GB"
          );
          narration += ` dated ${formattedDate}`;
        }
      } else {
        narration = `Receipt from ${SledgerName}`;

        // Add cheque details if available
        if (ChequeNo) {
          narration += ` No. ${ChequeNo}`;
        }
        if (DrawnOn) {
          narration += ` Drawn on ${DrawnOn}`;
        }
        if (ChequeDate) {
          // Format the date to DD/MM/YYYY
          const formattedDate = new Date(ChequeDate).toLocaleDateString(
            "en-GB"
          );
          narration += ` dated ${formattedDate}`;
        }
      }

      this.setState({ Narration: narration });
    }
  };

  handleEditClick = () => {
    if (!this.state.MoneyReceipt) {
      alert("Please select a Money Receipt first");
      return;
    }
    
    this.setState({
      isEditMode: true,
      isAddMode: false,
      isInitialLoad: false,
      editId: this.state.MoneyReceipt,
      isAuto: false,
      canPrint: false,
      isFieldsDisabled: false,
      // Disable Add, Edit and Print buttons when Edit is clicked
      isAddEnabled: false,
      isEditEnabled: false, // Disable Edit button after clicking
      isPrintEnabled: false,
      // Enable Save and Cancel buttons
      isSaveDisabled: false,
      isCancelDisabled: false,
      // Disable MoneyReceipt dropdown
      isMoneyReceiptDisabled: true
    });
  };

  handleAddClick = () => {
    // Reset all form fields and state
    this.setState(
      {
        // Basic form data
        id: 0,
        formData: {},
        success_msg: false,
        searchInvoice: "",
        date: new Date().toISOString().split("T")[0],
        modal_fullscreen: false,

        // Ledger and amount related
        F_LedgerMaster: "",
        F_SalesLedger: "",
        Amount: 0,
        Narration: "",
        LedgerMasterDr: "",
        LedgerMasterCr: "",
        currBalance: "0.00",
        MoneyMaster: [],
        currBalanceMaster: [],

        // Cheque details
        ChequeNo: "",
        DrawnOn: "",
        ChequeDate: "",

        // Auto/Manual mode data
        MR_AutoFill: [],
        manualData: [],
        isAuto: false,

        // Amount calculations
        openBalance: "0.00",
        LineTotalAmt: "0.00",
        NetAmt: "0.00",
        DueAmt: "0.00",
        diffAmt: "0.00",

        // Master data
        F_InvoiceMasterH: "",
        F_VoucherTypeMaster: "",

        // Invoice related
        InvoiceIds: [],
        NetAmounts: "",
        DueAmounts: "",
        voucherNo: "",

        // Edit mode flags
        isEditMode: false,
        editId: 0,
        isMoneyReceiptSelected: false,
        isLedgerSelected: false,
        MoneyReceipt: "",
        isInitialLoad: false,
        isAddMode: true,
        canPrint: false,
        isMoneyReceiptDisabled: false, // Enable MoneyReceipt dropdown
        isFieldsDisabled: false,
        // Update button states - enable Save and Cancel, disable others
        isAddEnabled: true,
        isEditEnabled: false, // Disable Edit button
        isPrintEnabled: false, // Disable Print button
        isSaveDisabled: false,
        isCancelDisabled: false,
      },
      () => {
        // Refresh MoneyReceipt dropdown data
        Fn_FillListData(
          this.obj,
          "SelectMoneyMaster",
          API_WEB_URLS.MASTER + "/0/token/SelectMoneyMaster/Id/0"
        );
      }
    );
  };

  btnSave_onClick = async event => {
    event.preventDefault();

    // Validate required fields
    if (!this.state.F_LedgerMaster) {
      showToastWithCloseButton("error", "Please select a Ledger");
      return;
    }
    if (!this.state.F_SalesLedger) {
      showToastWithCloseButton("error", "Please select a Sales Ledger");
      return;
    }
    if (!this.state.Amount || parseFloat(this.state.Amount) <= 0) {
      showToastWithCloseButton("error", "Please enter a valid Amount");
      return;
    }

    // Only allow save in edit mode if Edit button was clicked
    if (this.state.MoneyReceipt && !this.state.isEditMode) {
      showToastWithCloseButton(
        "error",
        "Please click Edit button first to modify the receipt"
      );
      return;
    }

    try {
      const currentData = this.state.isAuto
        ? this.state.MR_AutoFill
        : this.state.manualData;

      // Validate if there are any items to save
      if (!currentData || currentData.length === 0) {
        showToastWithCloseButton("error", "No items to save");
        return;
      }

      // Filter items with non-zero amounts
      const nonZeroItems = currentData.filter(item => {
        const amount = this.state.isAuto
          ? parseFloat(item.Amount)
          : parseFloat(item.editableAmount);
        return amount > 0;
      });

      if (nonZeroItems.length === 0) {
        showToastWithCloseButton("error", "Please enter at least one amount");
        return;
      }

      // Create arrays for the data
      const invoiceIds = nonZeroItems.map(item => item.Id);
      const dueAmounts = nonZeroItems.map(item => item.DueAmt);
      const paidAmounts = nonZeroItems.map(item =>
        this.state.isAuto ? item.Amount : item.editableAmount
      );

      // Create FormData object
      const vformData = new FormData();

      // Append all form data with proper field names
      vformData.append("F_LedgerMaster", this.state.F_LedgerMaster || "");
      vformData.append("F_SalesLedger", this.state.F_SalesLedger || "");
      vformData.append("ChequeNo", this.state.ChequeNo || 0);
      vformData.append("DrawnOn", this.state.DrawnOn || "");
      vformData.append("ChequeDate", this.state.ChequeDate || "");
      vformData.append("Narration", this.state.Narration || "");
      vformData.append("Amount", this.state.Amount || "");
      vformData.append("LedgerMasterDr", this.state.F_SalesLedger);
      vformData.append("LedgerMasterCr", this.state.F_LedgerMaster);
      vformData.append("DueAmt", dueAmounts.join(",") || "");
      vformData.append("NetAmt", paidAmounts.join(",") || "");
      vformData.append("isAuto", this.state.isAuto ? "true" : "false");
      vformData.append("InvoiceIds", invoiceIds.join(",") || "");
      vformData.append("VoucherDate", this.state.date || "");

      // Determine if this is an edit or new record
      const isEdit = this.state.MoneyReceipt && this.state.MoneyReceipt !== "";
      const recordId = isEdit ? this.state.MoneyReceipt : 0;

      // Call API to save data
      const res = await Fn_AddEditData(
        this.obj,
        { arguList: { id: recordId, formData: vformData } },
        this.API_URL_SAVEH,
        this.pushFormName,
        true
      );

      if (res && res.data && res.data.id) {
        this.setState(
          {
            MoneyReceipt: res.data.id,
            isEditMode: true,
            isAddMode: false,
            canPrint: true,
            isMoneyReceiptDisabled: false,
            isFieldsDisabled: true,
            isSaveDisabled: true,
            isCancelDisabled: true,
            isEditEnabled: true,
            isPrintEnabled: true,
            isAddEnabled: true,
          },
          () => {
            // Refresh MoneyReceipt dropdown data
            Fn_FillListData(
              this.obj,
              "SelectMoneyMaster",
              API_WEB_URLS.MASTER + "/0/token/SelectMoneyMaster/Id/0"
            );
            showToastWithCloseButton("success", "Data saved successfully");
          }
        );
      } else {
        showToastWithCloseButton("error", "Failed to save data. Please try again.");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      showToastWithCloseButton("error", error.message || "An error occurred while saving. Please try again.");
    }
  };

  handleToggleChange = (isAuto, e) => {
    // Prevent form submission
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ isAuto }, () => {
      if (isAuto) {
        // In auto mode, use MR_AutoFill data
        if (this.state.F_LedgerMaster) {
          Fn_FillListData(
            this.obj,
            "MR_AutoFill",
            `${API_WEB_URLS.MASTER}/0/token/MR_AutoFill/Id/${this.state.F_LedgerMaster}`
          );

          Fn_FillListData(
            this.obj,
            "currBalanceMaster",
            `${API_WEB_URLS.MASTER}/0/token/currBalanceMaster/Id/${this.state.F_LedgerMaster}`
          );
        }
      } else {
        // In manual mode, keep MR_AutoFill data but make amounts editable
        if (this.state.MR_AutoFill && this.state.MR_AutoFill.length > 0) {
          const manualData = this.state.MR_AutoFill.map(item => ({
            ...item,
            editableAmount: item.Amount,
            NetAmt: (parseFloat(item.DueAmt) - parseFloat(item.Amount)).toFixed(
              2
            ),
          }));

          // Calculate totals
          const totalDueAmount = manualData.reduce((sum, item) => {
            return sum + (parseFloat(item.DueAmt) || 0);
          }, 0);

          const totalNetAmount = manualData.reduce((sum, item) => {
            return sum + (parseFloat(item.NetAmt) || 0);
          }, 0);

          // Get current balance from currBalanceMaster
          const selectedLedger = this.state.currBalanceMaster.find(
            item => item.F_LedgerMaster == this.state.F_LedgerMaster
          );
          const currentBalance = selectedLedger
            ? selectedLedger.currBalance
            : "0.00";

          this.setState({
            manualData,
            currBalance: currentBalance,
            LineTotalAmt: totalDueAmount.toFixed(2),
            NetAmt: totalNetAmount.toFixed(2),
            diffAmt: totalDueAmount.toFixed(2),
          });
        }
      }
    });
  };

  handleAmountChange = (index, value) => {
    const currentData = this.state.isAuto
      ? this.state.MR_AutoFill
      : this.state.manualData;
    const dueAmount = parseFloat(currentData[index].DueAmt) || 0;
    const enteredAmount = parseFloat(value) || 0;

    // Allow editing if in edit mode (MoneyReceipt has value) regardless of due amount
    const validAmount = this.state.MoneyReceipt
      ? enteredAmount
      : Math.min(enteredAmount, dueAmount);

    if (this.state.isAuto) {
      const updatedData = [...this.state.MR_AutoFill];
      updatedData[index] = {
        ...updatedData[index],
        Amount: validAmount,
        NetAmt: validAmount, // Set NetAmt to match Amount in auto mode
      };

      // Calculate totals
      const totalAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.Amount) || 0);
      }, 0);

      const totalDueAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.DueAmt) || 0);
      }, 0);

      const totalNetAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.NetAmt) || 0);
      }, 0);

      // Calculate difference amount
      const diffAmount = parseFloat(
        (parseFloat(this.state.Amount) - totalAmount).toFixed(2)
      );

      // Get current balance from currBalanceMaster
      const selectedLedger = this.state.currBalanceMaster.find(
        item => item.F_LedgerMaster == this.state.F_LedgerMaster
      );
      const currentBalance = selectedLedger
        ? selectedLedger.currBalance
        : "0.00";

      // Extract data for non-zero Amount items
      const nonZeroItems = updatedData.filter(
        item => parseFloat(item.Amount) > 0
      );
      const invoiceIds = nonZeroItems.map(item => item.Id).join(",");
      const netAmounts = nonZeroItems.map(item => item.NetAmt).join(",");
      const dueAmounts = nonZeroItems.map(item => item.DueAmt).join(",");

      this.setState({
        MR_AutoFill: updatedData,
        currBalance: currentBalance,
        LineTotalAmt: totalDueAmount.toFixed(2),
        NetAmt: totalNetAmount.toFixed(2),
        diffAmt: diffAmount.toFixed(2),
        InvoiceIds: invoiceIds,
        NetAmounts: netAmounts,
        DueAmounts: dueAmounts,
      });
    } else {
      const updatedData = [...this.state.manualData];
      updatedData[index] = {
        ...updatedData[index],
        editableAmount: validAmount, // Removed toFixed here
        NetAmt: validAmount, // Removed toFixed here
      };

      // Calculate totals
      const totalAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.editableAmount) || 0);
      }, 0);

      const totalDueAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.DueAmt) || 0);
      }, 0);

      const totalNetAmount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.NetAmt) || 0);
      }, 0);

      // Calculate difference amount
      const diffAmount = parseFloat(
        (parseFloat(this.state.Amount) - totalAmount).toFixed(2)
      );

      // Get current balance from currBalanceMaster
      const selectedLedger = this.state.currBalanceMaster.find(
        item => item.F_LedgerMaster == this.state.F_LedgerMaster
      );
      const currentBalance = selectedLedger
        ? selectedLedger.currBalance
        : "0.00";

      // Extract data for non-zero Amount items
      const nonZeroItems = updatedData.filter(
        item => parseFloat(item.editableAmount) > 0
      );
      const invoiceIds = nonZeroItems.map(item => item.Id).join(",");
      const netAmounts = nonZeroItems.map(item => item.NetAmt).join(",");
      const dueAmounts = nonZeroItems.map(item => item.DueAmt).join(",");

      this.setState({
        manualData: updatedData,
        currBalance: currentBalance,
        LineTotalAmt: totalDueAmount.toFixed(2),
        NetAmt: totalNetAmount.toFixed(2),
        diffAmt: diffAmount.toFixed(2),
        InvoiceIds: invoiceIds,
        NetAmounts: netAmounts,
        DueAmounts: dueAmounts,
      });
    }
  };

  handleManualEntry = (index, field, value) => {
    if (!this.state.isAuto) {
      const updatedData = [...this.state.manualData];
      if (!updatedData[index]) {
        updatedData[index] = {
          sno: index + 1,
          VoucherNo: "",
          VoucherDate: "",
          DueAmt: "",
          NetAmt: "",
          diffAmt: "",
        };
      }
      updatedData[index][field] = value;
      this.setState({ manualData: updatedData });
    }
  };

  renderPaymentDetails() {
    const { F_SalesLedger, ChequeNo, DrawnOn, ChequeDate } = this.state;

    if (F_SalesLedger && F_SalesLedger !== "100060016") {
      return (
        <div
          style={{
            display: "flex",
            gap: "15px",
            marginBottom: "10px",
            marginTop: "10px",
          }}
        >
          <div>
            <label style={{ display: "block", marginBottom: "5px" }}>
              Cheque No.
            </label>
            <input
              type="text"
              name="ChequeNo"
              value={ChequeNo}
              onChange={this.handleChange}
              style={{
                width: "120px",
                padding: "4px",
                borderRadius: "2px",
                border: "1px solid #ddd",
              }}
            />
          </div>
          <div>
            <label style={{ display: "block", marginBottom: "5px" }}>
              Drawn On
            </label>
            <input
              type="text"
              name="DrawnOn"
              value={DrawnOn}
              onChange={this.handleChange}
              style={{
                width: "200px",
                padding: "4px",
                borderRadius: "2px",
                border: "1px solid #ddd",
              }}
            />
          </div>
          <div>
            <label style={{ display: "block", marginBottom: "5px" }}>
              Cheque Date
            </label>
            <input
              type="date"
              name="ChequeDate"
              value={ChequeDate}
              onChange={this.handleChange}
              style={{
                width: "130px",
                padding: "4px",
                borderRadius: "2px",
                border: "1px solid #ddd",
              }}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  tog_fullscreen() {
    this.setState(prevState => ({
      modal_fullscreen: !prevState.modal_fullscreen,
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  handleCancel = async () => {
    // Store the last selected Money Receipt ID
    const lastSelectedMoneyReceipt = this.state.MoneyReceipt;

    // Reset form fields and state
    this.setState(
      {
        // Basic form data
        id: 0,
        formData: {},
        success_msg: false,
        searchInvoice: "",
        date: new Date().toISOString().split("T")[0],
        modal_fullscreen: false,

        // Ledger and amount related
        F_LedgerMaster: "",
        F_SalesLedger: "",
        Amount: 0,
        Narration: "",
        LedgerMasterDr: "",
        LedgerMasterCr: "",
        currBalance: "0.00",
        MoneyMaster: [],
        currBalanceMaster: [],

        // Cheque details
        ChequeNo: "",
        DrawnOn: "",
        ChequeDate: "",

        // Auto/Manual mode data
        MR_AutoFill: [],
        manualData: [],
        isAuto: false,

        // Amount calculations
        openBalance: "0.00",
        LineTotalAmt: "0.00",
        NetAmt: "0.00",
        DueAmt: "0.00",
        diffAmt: "0.00",

        // Master data
        F_InvoiceMasterH: "",
        F_VoucherTypeMaster: "",

        // Invoice related
        InvoiceIds: [],
        NetAmounts: "",
        DueAmounts: "",
        voucherNo: "",

        // Edit mode flags
        isEditMode: false,
        editId: 0,
        isMoneyReceiptSelected: false,
        isLedgerSelected: false,
        MoneyReceipt: lastSelectedMoneyReceipt, // Keep the last selected Money Receipt
        isInitialLoad: false,
        isAddMode: false,
        canPrint: false,
        isMoneyReceiptDisabled: false,
        isFieldsDisabled: false,
        // Reset button states - enable Edit and Print, disable others
        isAddEnabled: true,
        isEditEnabled: true, // Enable Edit button
        isPrintEnabled: true, // Enable Print button
        isSaveDisabled: true,
        isCancelDisabled: true,
      },
      async () => {
        // If there was a last selected Money Receipt, fetch and fill its data
        if (lastSelectedMoneyReceipt) {
          const res = await Fn_FillListData(
            this.obj,
            "MoneyReceiptHEdit",
            `${API_WEB_URLS.MASTER}/0/token/MoneyReceiptHEdit/Id/${lastSelectedMoneyReceipt}`
          );

          const res1 = await Fn_FillListData(
            this.obj,
            "MoneyReceiptLEdit",
            `${API_WEB_URLS.MASTER}/0/token/MoneyReceiptLEdit/Id/${lastSelectedMoneyReceipt}`
          );

          // Set values from MoneyReceiptHEdit response
          if (res && res.length > 0) {
            this.setState({
              F_LedgerMaster: res[0].F_LedgerMaster || "",
              F_SalesLedger: res[0].F_SalesLedger || "",
              Amount: res[0].Amount || "",
              Narration: res[0].Narration || "",
              ChequeNo: res[0].ChequeNo || "",
              DrawnOn: res[0].DrawnOn || "",
              ChequeDate: res[0].ChequeDate || "",
              date: res[0].VoucherDate || "",
              LedgerMasterDr: res[0].F_SalesLedger || "",
              LedgerMasterCr: res[0].F_LedgerMaster || "",
              isAuto: false,
            });

            // If there's line item data, set it to manualData
            if (res1 && res1.length > 0) {
              const lineItems = res1.map((item, index) => ({
                sno: index + 1,
                Id: item.Id || "",
                VoucherNo: item.VoucherNo || "",
                VoucherDate: item.VoucherDate || "",
                DueAmt: item.DueAmt || "0.00",
                NetAmt: item.Paid || "0.00",
                editableAmount: item.Paid || "0.00",
              }));

              const totalDueAmount = res1.reduce((sum, item) => {
                return sum + (parseFloat(item.DueAmt) || 0);
              }, 0);

              const totalNetAmount = res1.reduce((sum, item) => {
                return sum + (parseFloat(item.Paid) || 0);
              }, 0);

              const selectedLedger = this.state.currBalanceMaster.find(
                item => item.F_LedgerMaster == res[0].F_LedgerMaster
              );
              const currentBalance = selectedLedger
                ? selectedLedger.currBalance
                : "0.00";

              this.setState({
                manualData: lineItems,
                currBalance: currentBalance,
                LineTotalAmt: totalDueAmount.toFixed(2),
                NetAmt: totalNetAmount.toFixed(2),
                diffAmt: (parseFloat(res[0].Amount) - totalNetAmount).toFixed(
                  2
                ),
              });
            }
          }
        }
      }
    );
  };

  render() {
    var parameters = [
      {
        name: "Id",
        values: [this.state.MoneyReceipt || 0],
      },
    ];

    const {
      date,
      F_LedgerMaster,
      F_SalesLedger,
      Amount,
      Narration,
      MR_AutoFill,
      manualData,
      LineTotalAmt,
      NetAmt,
      diffAmt,
      isAuto,
      LedgerMasterr,
      SalesLedgerr,
      MoneyReceipt,
      SelectMoneyMaster,
    } = this.state;
    return (
      <React.Fragment>
        <div
          className="page-content"
          style={{
            backgroundColor:
              this.state.VoucherGlobalOptions[0].BackgroundColor != "" &&
              this.state.VoucherGlobalOptions[0].BackgroundColor != undefined &&
              this.state.VoucherGlobalOptions[0].BackgroundColor != null
                ? this.state.VoucherGlobalOptions[0].BackgroundColor
                : "white",
          }}
        >
          <Container fluid>
            {/* Render Breadcrumb */}

            <Row>
              <Col lg="12">
                <AvForm
                  className="needs-validation"
                  onValidSubmit={this.btnSave_onClick}
                >
                  <Card
                    style={{
                      backgroundColor:
                        this.state.VoucherGlobalOptions[0].BackgroundColor !=
                          "" &&
                        this.state.VoucherGlobalOptions[0].BackgroundColor !=
                          undefined &&
                        this.state.VoucherGlobalOptions[0].BackgroundColor !=
                          null
                          ? this.state.VoucherGlobalOptions[0].BackgroundColor
                          : "#f1ced4",
                    }}
                  >
                    <CardBody>
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          padding: "20px",
                          maxWidth: "800px",
                          margin: "0 auto",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#cd853f",
                            padding: "8px",
                            borderRadius: "4px",
                            marginBottom: "15px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <label
                              style={{ color: "white", marginRight: "10px" }}
                            >
                              Search Receipt
                            </label>
                            <select
                              name="MoneyReceipt"
                              value={MoneyReceipt}
                              onChange={this.handleChange}
                              disabled={this.state.isMoneyReceiptDisabled}
                              style={{
                                width: "100%",
                                padding: "4px",
                                borderRadius: "2px",
                                border: "1px solid #ddd",
                                backgroundColor: "white",
                                cursor: this.state.isMoneyReceiptDisabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <option value="">Select Money Receipt</option>
                              {SelectMoneyMaster &&
                                SelectMoneyMaster.map(option => (
                                  <option key={option.Id} value={option.Id}>
                                    {option.ReceiptNo} &nbsp;&nbsp;{" "}
                                    {option.Name} &nbsp;&nbsp;{" "}
                                    {option.VoucherDate}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <label
                              style={{ color: "white", marginRight: "10px" }}
                            >
                              Date
                            </label>
                            <input
                              type="text"
                              value={new Date().toLocaleDateString("en-GB")}
                              readOnly
                              style={{
                                padding: "4px",
                                width: "90px",
                                borderRadius: "2px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>
                        </div>

                        <div style={{ marginBottom: "15px" }}>
                          <div
                            style={{
                              display: "flex",
                              marginBottom: "10px",
                              gap: "15px",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <label
                                style={{
                                  display: "block",
                                  marginBottom: "5px",
                                }}
                              >
                                Ledger Name
                              </label>
                              <select
                                name="F_LedgerMaster"
                                value={F_LedgerMaster}
                                onChange={this.handleChange}
                                disabled={
                                  this.state.MoneyReceipt &&
                                  !this.state.isEditMode
                                }
                                style={{
                                  width: "100%",
                                  padding: "4px",
                                  borderRadius: "2px",
                                  border: "1px solid #ddd",
                                  backgroundColor: "white",
                                }}
                              >
                                <option value="">Select Ledger</option>
                                {LedgerMasterr &&
                                  LedgerMasterr.map(option => (
                                    <option key={option.Id} value={option.Id}>
                                      {option.Name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "15px",
                              marginBottom: "10px",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <label
                                style={{
                                  display: "block",
                                  marginBottom: "5px",
                                }}
                              >
                                Sales Ledger
                              </label>
                              <select
                                name="F_SalesLedger"
                                value={F_SalesLedger}
                                onChange={this.handleChange}
                                style={{
                                  width: "100%",
                                  padding: "4px",
                                  borderRadius: "2px",
                                  border: "1px solid #ddd",
                                  backgroundColor: "white",
                                }}
                              >
                                <option value="">Select Sales Ledger</option>
                                {SalesLedgerr &&
                                  SalesLedgerr.map(option => (
                                    <option key={option.Id} value={option.Id}>
                                      {option.Name}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            
                          </div>

                          {this.renderPaymentDetails()}

                          <div style={{ marginBottom: "15px" }}>
                            <label
                              style={{ display: "block", marginBottom: "5px" }}
                            >
                              Narration
                            </label>
                            <input
                              type="text"
                              name="Narration"
                              value={Narration}
                              onChange={this.handleChange}
                              style={{
                                width: "100%",
                                padding: "4px",
                                borderRadius: "2px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              marginBottom: "15px",
                            }}
                          >
                            <span style={{ fontSize: "13px" }}>Mode:</span>
                            <div
                              style={{
                                display: "flex",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                overflow: "hidden",
                                width: "fit-content",
                                opacity: this.state.MoneyReceipt ? 0.5 : 1,
                              }}
                            >
                              <button
                                style={{
                                  padding: "4px 12px",
                                  border: "none",
                                  backgroundColor: isAuto
                                    ? "#f0f0f0"
                                    : "#4169e1",
                                  color: isAuto ? "#333" : "white",
                                  cursor: this.state.MoneyReceipt
                                    ? "not-allowed"
                                    : "pointer",
                                  fontSize: "13px",
                                }}
                                onClick={e => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (!this.state.MoneyReceipt) {
                                    this.handleToggleChange(false, e);
                                  }
                                }}
                                type="button"
                                disabled={this.state.MoneyReceipt}
                              >
                                Manual
                              </button>
                              <button
                                style={{
                                  padding: "4px 12px",
                                  border: "none",
                                  backgroundColor: isAuto
                                    ? "#4169e1"
                                    : "#f0f0f0",
                                  color: isAuto ? "white" : "#333",
                                  cursor: this.state.MoneyReceipt
                                    ? "not-allowed"
                                    : "pointer",
                                  fontSize: "13px",
                                }}
                                onClick={e => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (!this.state.MoneyReceipt) {
                                    this.handleToggleChange(true, e);
                                  }
                                }}
                                type="button"
                                disabled={this.state.MoneyReceipt}
                              >
                                Auto
                              </button>
                            </div>

                            <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              marginBottom: "15px",
                            }}
                          >
                            <span style={{ fontSize: "13px" }}>Amount:</span>
                              <input
                                type="number"
                                name="Amount"
                                value={Amount}
                                onChange={this.handleChange}
                                onFocus={event => event.target.select()}
                                style={{
                                  width: "100px",
                                  padding: "4px",
                                  borderRadius: "2px",
                                  border: "1px solid #ddd",
                                  textAlign: "right",
                                }}
                              />
                            </div>

                          </div>

                          

                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "white",
                              }}
                            >
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  tableLayout: "fixed",
                                }}
                              >
                                <thead>
                                  <tr
                                    style={{
                                      backgroundColor: "#f8f9fa",
                                      borderBottom: "2px solid #ccc",
                                    }}
                                  >
                                    <th
                                      style={{
                                        ...tableHeaderStyle,
                                        width: "50px",
                                        textAlign: "center",
                                      }}
                                    >
                                      SNo
                                    </th>
                                    <th
                                      style={{
                                        ...tableHeaderStyle,
                                        width: "180px",
                                      }}
                                    >
                                      Invoice No.
                                    </th>
                                    <th
                                      style={{
                                        ...tableHeaderStyle,
                                        width: "80px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Date
                                    </th>
                                    <th
                                      style={{
                                        ...tableHeaderStyle,
                                        width: "150px",
                                        textAlign: "right",
                                      }}
                                    >
                                      Due Amount
                                    </th>
                                    <th
                                      style={{
                                        ...tableHeaderStyle,
                                        width: "150px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Paid Amount
                                    </th>
                                   
                                  </tr>
                                </thead>
                              </table>
                              <div
                                style={{
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                  borderTop: "1px solid #ddd",
                                }}
                              >
                                <table
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <tbody>
                                    {(isAuto ? MR_AutoFill : manualData) &&
                                      (isAuto ? MR_AutoFill : manualData).map(
                                        (item, index) => (
                                          <tr
                                            key={index}
                                            style={{
                                              backgroundColor:
                                                index % 2 === 0
                                                  ? "#fff"
                                                  : "#f9f9f9",
                                              borderBottom: "1px solid #ddd",
                                              ":hover": {
                                                backgroundColor: "#f5f5f5",
                                              },
                                            }}
                                          >
                                            <td
                                              style={{
                                                ...tableCellStyle,
                                                width: "50px",
                                                textAlign: "center",
                                              }}
                                            >
                                              {index + 1}
                                            </td>
                                            <td
                                              style={{
                                                ...tableCellStyle,
                                                width: "180px",
                                                // fontFamily: "monospace",
                                                 fontSize: "13px",
                                              }}
                                            >
                                              {item.VoucherNo}
                                            </td>
                                            <td
                                              style={{
                                                ...tableCellStyle,
                                                width: "80px",
                                                textAlign: "center",
                                              }}
                                            >
                                              {item.VoucherDate}
                                            </td>
                                            <td
                                              style={{
                                                ...tableCellStyle,
                                                width: "150px",
                                                textAlign: "right",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  padding: "4px",
                                                  textAlign: "right",
                                                  // fontFamily: "monospace",
                                                   fontSize: "13px",
                                                }}
                                              >
                                                {item.DueAmt}
                                              </div>
                                            </td>

                                            <td
                                              style={{
                                                ...tableCellStyle,
                                                width: "150px",
                                                textAlign: "center",
                                              }}
                                            >
                                              {isAuto ? (
                                                <div
                                                  style={{
                                                    padding: "4px",
                                                    textAlign: "right",
                                                    // fontFamily: "monospace",
                                                     fontSize: "13px",
                                                    color: "#4169e1",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  {item.NetAmt}
                                                </div>
                                              ) : (
                                                <input
                                                  type="number"
                                                  value={
                                                    item.editableAmount || 0
                                                  }
                                                  onChange={e =>
                                                    this.handleAmountChange(
                                                      index,
                                                      e.target.value
                                                    )
                                                  }
                                                  onFocus={event =>
                                                    event.target.select()
                                                  }
                                                  style={{
                                                    width: "100%",
                                                    padding: "4px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "2px",
                                                    textAlign: "right",
                                                    // fontFamily: "monospace",
                                                     fontSize: "13px",
                                                  }}
                                                />
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    {/* Empty row for spacing */}
                                    <tr
                                      style={{
                                        height: "10px",
                                        backgroundColor: "#fff",
                                      }}
                                    >
                                      <td
                                        colSpan="5"
                                        style={{ borderBottom: "none" }}
                                      ></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              backgroundColor: "#ffe4e1",
                              padding: "8px",
                              borderRadius: "4px",
                              marginBottom: "15px",
                            }}
                          >
                            <div>
                              <label style={{ marginRight: "10px" }}>
                                Curr. Balance
                              </label>
                              <input
                                type="text"
                                value={this.state.currBalance || "0.00"}
                                readOnly
                                style={{
                                  width: "80px",
                                  padding: "4px",
                                  textAlign: "right",
                                  border: "1px solid #ddd",
                                  borderRadius: "2px",
                                  // fontFamily: "monospace",
                                  fontSize: "13px",
                                }}
                              />
                              <span style={{ marginLeft: "5px" }}>Dr.</span>
                            </div>

                            <div>
                              <label style={{ marginRight: "10px" }}>
                                Line Total Amt
                              </label>
                              <input
                                type="text"
                                value={LineTotalAmt || "0.00"}
                                readOnly
                                style={{
                                  width: "80px",
                                  padding: "4px",
                                  textAlign: "right",
                                  border: "1px solid #ddd",
                                  borderRadius: "2px",
                                  // fontFamily: "monospace",
                                  fontSize: "13px",
                                }}
                              />
                            </div>

                            <div>
                              <label style={{ marginRight: "10px" }}>
                                Diff. Amt
                              </label>
                              <input
                                type="text"
                                value={diffAmt || "0.00"}
                                readOnly
                                style={{
                                  width: "80px",
                                  padding: "4px",
                                  textAlign: "right",
                                  border: "1px solid #ddd",
                                  borderRadius: "2px",
                                  // fontFamily: "monospace",
                                  fontSize: "13px",
                                }}
                              />
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "10px",
                              marginTop: "15px",
                            }}
                          >
                            <button
                              style={{
                                ...buttonStyle,
                                opacity: this.state.isAddEnabled ? 1 : 0.5,
                                cursor: this.state.isAddEnabled
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              disabled={!this.state.isAddEnabled}
                              onClick={this.handleAddClick}
                            >
                              Add
                            </button>
                            <button
                              style={{
                                ...buttonStyle,
                                opacity: this.state.isEditEnabled ? 1 : 0.5,
                                cursor: this.state.isEditEnabled
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              disabled={!this.state.isEditEnabled}
                              onClick={this.handleEditClick}
                            >
                              Edit
                            </button>
                            <button
                              style={{
                                ...buttonStyle,
                                opacity: this.state.isSaveDisabled ? 0.5 : 1,
                                cursor: this.state.isSaveDisabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              disabled={this.state.isSaveDisabled}
                              onClick={this.btnSave_onClick}
                            >
                              Save
                            </button>

                            <button
                              style={{
                                ...buttonStyle,
                                opacity: this.state.isCancelDisabled ? 0.5 : 1,
                                cursor: this.state.isCancelDisabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              disabled={this.state.isCancelDisabled}
                              onClick={this.handleCancel}
                            >
                              Cancel
                            </button>
                            <Button
                              type="button"
                              color="danger"
                              style={{
                                marginLeft: 10,
                                opacity: this.state.isPrintEnabled ? 1 : 0.5,
                                cursor: this.state.isPrintEnabled
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              disabled={!this.state.MoneyReceipt || parseInt(this.state.MoneyReceipt) <= 0}
                              onClick={this.tog_fullscreen}
                              className="mr-1 waves-effect waves-light"
                            >
                              Print
                            </Button>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>

                  <Card
                    style={{
                      backgroundColor:
                        API_WEB_URLS.Customer === 7
                          ? this.state.VoucherGlobalOptions[0].BackgroundColor
                          : "#a8ead4",
                    }}
                  >
                    <CardBody>
                      <CardTitle className="h4"></CardTitle>

                      <div>
                        <Modal
                          size="xl"
                          isOpen={this.state.modal_fullscreen}
                          toggle={this.tog_fullscreen}
                          className="modal-fullscreen"
                        >
                          <div className="modal-header">
                            <h5
                              className="modal-title mt-0"
                              id="exampleModalFullscreenLabel"
                            >
                              Print
                            </h5>
                            <button
                              onClick={() =>
                                this.setState({ modal_fullscreen: false })
                              }
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            {API_WEB_URLS.Customer == 7 ? (
                              <BoldReportViewerComponent
                                id="reportviewer-container"
                                reportServiceUrl={
                                  "https://boldreports.shinewellinnovation.com/reporting/reportservice/api/Viewer"
                                }
                                reportServerUrl={
                                  "https://boldreports.shinewellinnovation.com/reporting/api/site/site1"
                                }
                                serviceAuthorizationToken={
                                  "bearer " + this.state.BoldToken[0].Token
                                }
                                reportPath={"/CgDemo/MoneyReceipt"}
                                printMode={true}
                                parameters={parameters}
                              ></BoldReportViewerComponent>
                            ) 
                            : API_WEB_URLS.Customer == 11 ? (
                              <BoldReportViewerComponent
                              id="reportviewer-container"
                              reportServiceUrl={
                                "https://boldreports.shinewellinnovation.com/reporting/reportservice/api/Viewer"
                              }
                              reportServerUrl={
                                "https://boldreports.shinewellinnovation.com/reporting/api/site/site1"
                              }
                              serviceAuthorizationToken={
                                "bearer " + this.state.BoldToken[0].Token
                              }
                              reportPath={"/BhagirathPackaging/MoneyReceipt"}
                              printMode={true}
                              parameters={parameters}
                            ></BoldReportViewerComponent>
                            ) : API_WEB_URLS.Customer == 13 ? (
                              <BoldReportViewerComponent
                              id="reportviewer-container"
                              reportServiceUrl={
                                "https://boldreports.shinewellinnovation.com/reporting/reportservice/api/Viewer"
                              }
                              reportServerUrl={
                                "https://boldreports.shinewellinnovation.com/reporting/api/site/site1"
                              }
                              serviceAuthorizationToken={
                                "bearer " + this.state.BoldToken[0].Token
                              }
                              reportPath={"/Lakshay/MoneyReceipt"}
                              printMode={true}
                              parameters={parameters}
                            ></BoldReportViewerComponent>
                            ) :   API_WEB_URLS.Customer == 14 ? (
                              <BoldReportViewerComponent
                              id="reportviewer-container"
                              reportServiceUrl={
                                "https://boldreports.shinewellinnovation.com/reporting/reportservice/api/Viewer"
                              }
                              reportServerUrl={
                                "https://boldreports.shinewellinnovation.com/reporting/api/site/site1"
                              }
                              serviceAuthorizationToken={
                                "bearer " + this.state.BoldToken[0].Token
                              }
                              reportPath={"/Mahaveer/MoneyReceiptOG"}
                              printMode={true}
                              parameters={parameters}
                            ></BoldReportViewerComponent>
                            ) : null}
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              onClick={this.tog_fullscreen}
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </Modal>
                      </div>
                    </CardBody>
                  </Card>
                </AvForm>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const tableHeaderStyle = {
  padding: "8px 12px",
  textAlign: "left",
  borderBottom: "2px solid #ccc",
  backgroundColor: "#f8f9fa",
  fontSize: "13px",
  fontWeight: "600",
  color: "#333",
  whiteSpace: "nowrap",
};

const tableCellStyle = {
  padding: "8px 12px",
  borderBottom: "1px solid #ddd",
  fontSize: "13px",
   color: "#333",
  whiteSpace: "nowrap",
};

const buttonStyle = {
  padding: "6px 12px",
  backgroundColor: "#4169e1",
  color: "white",
  border: "1px solid #2a4eb9",
  borderRadius: "3px",
  cursor: "pointer",
  fontSize: "12px",
  transition: "background-color 0.2s",
};
export default compose(container)(AddMoneyReceipt);
